import styled from 'styled-components'

export const GridContainer = styled.section`
  height: ${(props) => (props.fullHeight ? '100%' : null)};

  & > .grid {
    margin: 0;
    height: ${(props) => (props.fullHeight ? '100%' : null)};

    & > .row {
      padding-top: 5px;
      padding-bottom: 5px;
      padding: ${(props) => (props.noPadding || props.noRowPadding ? 0 : null)};
      margin-bottom: ${(props) => (props.noRowPadding ? 2 : null)};
      padding-top: ${(props) => (props.smallPadding ? '2px !important' : null)};
      padding-bottom: ${(props) => (props.smallPadding ? '2px !important' : null)};

      & > .column {
        padding-right: 5px;
        padding-left: 5px;

        display: ${(props) => (props.flexColumn ? 'flex' : null)};
        padding: ${(props) => (props.noPadding ? 0 : null)};
        overflow: ${(props) => (props.scrolableColumn ? 'auto' : null)};
      }
    }
  }

  & .ui.celled.grid > .row > .column {
    padding: 0;
  }
`
